<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class=" col-sm-12">
            <div class="row h-100">
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="active-check" type="checkbox" value=""
                                v-model="compState.active">
                            <label class="form-check-label" for="active-check">Active this rule</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Name</h6>
                </label>
                <input v-model="compState.name" class="form-control" type="text" placeholder="Name" maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Code</h6>
                </label>
                <input v-model="compState.code" class="form-control" type="text" placeholder="Code" maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Alternate Name1</h6>
                </label>
                <input v-model="compState.alternateName1" class="form-control" type="text" placeholder="Code"
                    maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Alternate Name1</h6>
                </label>
                <input v-model="compState.alternateName1" class="form-control" type="text" placeholder="Code"
                    maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Rate</h6>
                </label>
                <div class="input-group">
                    <select v-model="compState.taxRate" class="form-select" aria-label="Tax Rate">
                        <option value="">Tax Rate</option>
                        <option value="Tax">Tax</option>
                        <option value="Tax2">Tax2</option>
                        <option value="Tax3">Tax3</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-sm-6"></div>
        <div class="col-sm-6">
            <div class="checkbox-checked d-flex gap-3 align-items-center">
                <label>
                    <h6 class="f-w-700">Member</h6>
                </label>
                <div>
                    <div class="form-check">
                        <input class="form-check-input" id="flexRadioDefault1" type="radio" name="flexRadioDefault"
                            value="member" v-model="compState.member">
                        <label class="form-check-label" for="flexRadioDefault1">Member Only</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="flexRadioDefault2" type="radio" name="flexRadioDefault"
                            value="nonMember" v-model="compState.member">
                        <label class="form-check-label" for="flexRadioDefault2">Non Member</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="flexRadioDefault3" type="radio" name="flexRadioDefault"
                            value="everyone" v-model="compState.member">
                        <label class="form-check-label" for="flexRadioDefault3">Everyone</label>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { usePromotionStore } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

const promotionStore = usePromotionStore()

const compState = reactive({
    id: '',
    name: '',
    code: '',
    active: false,
    alternateName1: '',
    alternateName2: '',
    taxRate: '',
    member: ''
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.id = tempActivePromotion.value.basic.id
        compState.name = tempActivePromotion.value.basic.name
        compState.code = tempActivePromotion.value.basic.code
        compState.active = tempActivePromotion.value.basic.active
        compState.alternateName1 = tempActivePromotion.value.basic.alternateName1
        compState.alternateName2 = tempActivePromotion.value.basic.alternateName2
        compState.taxRate = tempActivePromotion.value.basic.taxRate
        compState.member = tempActivePromotion.value.basic.member
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.id = promotion.basic.id
        compState.name = promotion.basic.name
        compState.code = promotion.basic.code
        compState.active = promotion.basic.active
        compState.alternateName1 = promotion.basic.alternateName1
        compState.alternateName2 = promotion.basic.alternateName2
        compState.taxRate = promotion.basic.taxRate
        compState.member = promotion.basic.member
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        basic: {
            id: newVal.id,
            name: newVal.name,
            code: newVal.code,
            active: newVal.active,
            alternateName1: newVal.alternateName1,
            alternateName2: newVal.alternateName2,
            taxRate: newVal.taxRate,
            member: newVal.member
        }
    } as Promotion)
}, { deep: true });

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>